import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { EventTypes } from "@services/tracking/types/eventTypes";
import { SearchFilterTrackingInfo } from "@services/tracking/types/trackingInfo/searchFilterTrackingInfo";

import { getPageInfo, getUserInfo } from "../../pageImpressionTracker";

const trackSearchFilterSelected = (
    facetName: string,
    facetValue: string,
    index: string,
) => {
    const event: TypedAnalyticsEvent<SearchFilterTrackingInfo> = {
        event: EventTypes.SearchFilterImpression,
        payload: {
            eventData: {
                filter: `${facetName}:${encodeURIComponent(facetValue)}`,
                index,
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackSearchFilterSelected };
